/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type GenerateSummaryByUserReportInput = {
    companyId: string;
    exportType: string;
};
export type ReportsPageGenerateSummaryByUserReportMutationVariables = {
    input: GenerateSummaryByUserReportInput;
};
export type ReportsPageGenerateSummaryByUserReportMutationResponse = {
    readonly generateSummaryByUserReport: {
        readonly fileContent: string;
        readonly fileName: string;
        readonly mimeType: string;
    };
};
export type ReportsPageGenerateSummaryByUserReportMutation = {
    readonly response: ReportsPageGenerateSummaryByUserReportMutationResponse;
    readonly variables: ReportsPageGenerateSummaryByUserReportMutationVariables;
};



/*
mutation ReportsPageGenerateSummaryByUserReportMutation(
  $input: GenerateSummaryByUserReportInput!
) {
  generateSummaryByUserReport(input: $input) {
    fileContent
    fileName
    mimeType
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateSummaryByUserReportPayload",
    "kind": "LinkedField",
    "name": "generateSummaryByUserReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileContent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportsPageGenerateSummaryByUserReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportsPageGenerateSummaryByUserReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db34b199893c676edc73da88dc9803dd",
    "id": null,
    "metadata": {},
    "name": "ReportsPageGenerateSummaryByUserReportMutation",
    "operationKind": "mutation",
    "text": "mutation ReportsPageGenerateSummaryByUserReportMutation(\n  $input: GenerateSummaryByUserReportInput!\n) {\n  generateSummaryByUserReport(input: $input) {\n    fileContent\n    fileName\n    mimeType\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f6d7c8655839fc40375bbf749b2ae722';
export default node;
